module.exports = __webpack_public_path__ + "static/media/estrategia_icon.2145b4e1.svg";